// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__2m5T0","Logo":"Toolbar_Logo__1Wonj","DesktopOnly":"Toolbar_DesktopOnly__39KB1"};